import { renderReportPdf } from "../export/reportPdf";

function openDoc(doc) {
  const blob = doc.output("blob");
  const url = URL.createObjectURL(blob);
  window.open(url, "_blank", "noopener");
}

export function openSampleReportPdf() {
  const doc = renderReportPdf({
    title: "Communication snapshot",
    subtitle: "Sample report for admin review",
    property: "1847 Maple Ridge Dr, Sacramento, CA 95831",
    status: "Open",
    clientRole: "Buyer file",
    generatedAt: "August 22, 2026",
    generatedBy: "Admin preview",
    exportType: "agent",
    parties: {
      broker: "Elena Vasquez — River Oak Brokerage",
      agent: "Marcus Chen",
      client: "Priya & James Ellison",
    },
    partyEmails: {
      broker: "elena@riveroak.example",
      agent: "marcus@riveroak.example",
      client: "ellison@example.com",
    },
    timeline: [
      {
        senderName: "Priya Ellison",
        stamp: "Aug 18, 2026 · 4:12 PM",
        text: "We are comfortable with the credit in lieu of roof work if the inspector’s photos stay in the file.",
        attachments: [],
      },
      {
        senderName: "Marcus Chen",
        stamp: "Aug 18, 2026 · 4:40 PM",
        text: "Agreed. I will confirm the credit language with escrow this evening and send the addendum for initials.",
        attachments: [],
      },
    ],
    attachments: [
      { name: "Inspection-summary.pdf", stamp: "Aug 18, 2026", type: "PDF" },
      { name: "Pre-approval-Ellison.pdf", stamp: "Jul 12, 2026", type: "PDF" },
    ],
    checklistType: "buyer",
    checklistSections: [
      {
        title: "Checklist summary",
        lines: [
          "Location: Pocket / Greenhaven, suburban, commute under 35 minutes",
          "Home type: Single-family, single-story preferred",
          "Must-haves: Main-floor primary, office nook, fenced yard",
        ],
      },
    ],
    disclaimer: "Sample only. Client checklists are strictly for internal use.",
  });
  openDoc(doc);
}

export function openSampleArchivePdf() {
  const doc = renderReportPdf({
    title: "Archive snapshot",
    subtitle: "Sample archive for admin review",
    property: "912 Harbor View, West Sacramento",
    status: "Closed",
    clientRole: "Seller file",
    generatedAt: "June 14, 2026",
    generatedBy: "Admin preview",
    exportType: "broker",
    parties: {
      broker: "Morgan Ellison",
      agent: "Jordan Hale",
      client: "Dana Ortiz",
    },
    partyEmails: {
      broker: "broker@dreamhome.local",
      agent: "agent@dreamhome.local",
      client: "dana@example.com",
    },
    timeline: [
      {
        senderName: "Jordan Hale",
        stamp: "May 28, 2026",
        text: "Accepted. Retention copy queued for broker and agent.",
        attachments: [],
      },
    ],
    attachments: [{ name: "Closing-snapshot.pdf", stamp: "June 14, 2026", type: "PDF" }],
    checklistType: "seller",
    checklistSections: [
      {
        title: "Archive notes",
        lines: ["Portfolio shared May 2. Listed May 9. Closed June 14. Sample data only."],
      },
    ],
    disclaimer: "Sample archive record for internal admin review.",
  });
  openDoc(doc);
}

export function openSampleSaleClosePdf() {
  const doc = renderReportPdf({
    title: "Sale close report",
    subtitle: "Sample close for admin review",
    property: "1847 Maple Ridge Dr, Sacramento, CA 95831",
    status: "Closed",
    clientRole: "Buyer file",
    generatedAt: "August 15, 2026",
    generatedBy: "Admin preview",
    exportType: "broker",
    parties: {
      broker: "Elena Vasquez — River Oak Brokerage",
      agent: "Marcus Chen",
      client: "Priya & James Ellison (buyers) · Dana Ortiz (seller)",
    },
    partyEmails: {
      broker: "elena@riveroak.example",
      agent: "marcus@riveroak.example",
      client: "ellison@example.com",
    },
    closeTerms: [
      ["Close date", "August 15, 2026"],
      ["Purchase price", "$875,000"],
      ["Earnest money", "$25,000"],
      ["Credits", "$8,500 roof credit at close"],
      ["Escrow", "Valley Title · file 26-4481"],
      ["Possession", "Close of escrow"],
      ["Commission", "Internal recap only — sample figures, not a DRE filing"],
    ],
    timeline: [
      {
        senderName: "Marcus Chen",
        stamp: "Aug 15, 2026 · 11:20 AM",
        text: "Funds received. Keys released at close. Retention copy queued for broker and agent.",
        attachments: [],
      },
      {
        senderName: "Elena Vasquez",
        stamp: "Aug 15, 2026 · 2:05 PM",
        text: "File marked closed. Sample sale close report generated for internal review.",
        attachments: [],
      },
    ],
    attachments: [
      { name: "Closing-statement-sample.pdf", stamp: "Aug 15, 2026", type: "PDF" },
      { name: "Grant-deed-sample.pdf", stamp: "Aug 15, 2026", type: "PDF" },
    ],
    checklistType: "buyer",
    checklistHeading: "File recap",
    checklistSections: [
      {
        title: "Checklist at close",
        lines: [
          "Buyer checklist completed through transaction notes.",
          "Inspection credit documented in the file.",
          "Sample data only — not a government close record.",
        ],
      },
    ],
    disclaimer:
      "Sample sale close report for internal admin review. Not a California DRE filing or certified close package.",
    pageFooter: "DreamHome Journey · sale close record · sample",
  });
  openDoc(doc);
}
